// Perspective colors — one hue per personality type, reserved for people
// (avatars, blobs, feature icons) and never for buttons, nav, or surfaces.
// Ordered so hues alternate across the growth/warmth/drive/focus families
// instead of running four near-identical shades in sequence.
export const PERSPECTIVE_COLORS = [
    "#5852c4",
    "#fbb877",
    "#2fa39c",
    "#e84c8e",
    "#5fa37c",
    "#7e78de",
    "#fb9a5e",
    "#84d6d0",
    "#b92a6a",
    "#3f8060",
    "#ada8ee",
    "#ffd3a8",
    "#f2766a",
    "#8ac79b",
    "#c6d6f6",
    "#bbe3b4",
] as const;
